module.exports = "/layout/app/images/bg-section-select-your-theme-before.e04f5c62.svg";